export function formatBigNumber(nr?: number, defaultStr = '', roundDown = false) {
    if (nr === undefined) {
        return defaultStr;
    }

    if (roundDown) {
        const formatter = Intl.NumberFormat('en', {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            notation: 'compact',
            minimumFractionDigits: 1,
            maximumFractionDigits: 4,
            minimumSignificantDigits: 1,
            maximumSignificantDigits: 4
        });
        return formatter.format(nr);
    }

    const formatter = Intl.NumberFormat('en', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        notation: 'compact',

    });
    return formatter.format(nr);
}
